export default "__VITE_ASSET__BsOnysCG__"